import { Spin } from 'antd'
import { AppRoutes } from 'App'
import AppContext from 'context/AppContext'
import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { DEFAULT_API_TOKEN } from 'utils/const'
import { clearLoginSession } from 'utils/helpers'
import { AuthState } from 'utils/types'

const LogoutPage = () => {
    const navigate = useNavigate()
    const { setToken, setAuthState } = useContext(AppContext)

    useEffect(() => {
        clearLoginSession()
        setToken(DEFAULT_API_TOKEN)
        setAuthState(AuthState.LOGGED_OUT)
        navigate(`/${AppRoutes.auth}`, { replace: true })
    }, [navigate, setToken, setAuthState])

    return <Spin style={{ margin: '40px auto', display: 'block' }} />
}

export default LogoutPage